import { Component, Input, OnInit } from '@angular/core';
import { MovieModel } from 'src/app/core/interfaces/movie.model';

@Component({
  selector: 'app-poster-list',
  templateUrl: './poster-list.component.html',
  styleUrls: ['./poster-list.component.css']
})
export class PosterListComponent implements OnInit {
  @Input() movies: MovieModel[] = [];
  @Input() title: string;
  constructor() { }

  ngOnInit(): void {

  }

}
